import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Card,
  Space,
  Spin,
  Typography,
  message,
} from "antd";
import axios from "axios";
import { ELEVENLABS_CONFIG } from "../../config/elevenlabs-api";

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const KnowledgeBaseForm = ({ onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      const entryData = {
        type: values.type,
        title: values.title,
        ...(values.type === "Text"
          ? { text: values.content }
          : { url: values.content }),
      };

      const endpoint =
        values.type === "Text"
          ? `${ELEVENLABS_CONFIG.BASE_URL}/knowledge-base/text`
          : `${ELEVENLABS_CONFIG.BASE_URL}/knowledge-base/url`;

      await axios.post(endpoint, entryData, {
        headers: {
          "xi-api-key": ELEVENLABS_CONFIG.API_KEY,
        },
      });

      message.success("Knowledge base entry added successfully");
      form.resetFields();
      onSubmit();
    } catch (err) {
      message.error(
        err.response?.data?.message || "An error occurred while saving"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTypeChange = (value) => {
    form.setFieldsValue({ content: "" });
  };

  return (
    <Card
      // title={<Title level={3} style={{ margin: 0 }}>Add Knowledge Base Entry</Title>}
      style={{ maxWidth: 600, margin: "0 auto" }}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ type: "Text" }}
        >
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please select a type" }]}
          >
            <Select onChange={handleTypeChange}>
              <Option value="Text">Text</Option>
              <Option value="URL">URL</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: "Please enter a title" }]}
          >
            <Input placeholder="Enter title" />
          </Form.Item>

          <Form.Item
            label="Content"
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.type !== currentValues.type
            }
          >
            {({ getFieldValue }) => {
              const type = getFieldValue("type");
              return (
                <Form.Item
                  name="content"
                  noStyle
                  rules={[{ required: true, message: "Please enter content" }]}
                >
                  {type === "Text" ? (
                    <TextArea rows={5} placeholder="Enter text content" />
                  ) : (
                    <Input type="url" placeholder="Enter URL" />
                  )}
                </Form.Item>
              );
            }}
          </Form.Item>

          <Form.Item>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button type="default" onClick={onClose} disabled={loading}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                Add Entry
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};

export default KnowledgeBaseForm;
